// Centralized contact information used across the app
export const contactInfo = {
  email: 'info@nqa1.in',
  phone: '9475707905',
  address: 'Plot No- 1759, Kaliganj, P.o-arrah, Bidhannagar, Bardhaman, Durgapur Mc, West Bengal, India, 713212'
};
